import React, { useState } from 'react';
import { IoIosSave } from "react-icons/io";

export default function BankDetailsUpdate({ value, index, placeholder, updateBankDetail }) {
    const [selectValue, setSelectValue] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
    const [accountNumber, setAccountNumber] = useState('');

    const handleSave = () => {
        if (accountNumber.trim() === '') {
            alert('Account number cannot be empty!');
            return;
        }
        updateBankDetail({ accountNumber });
        setAccountNumber(''); // Clear after save
        setSelectValue(''); // Reset selection
    };

    const handleSaveNotAble = () => {
        updateBankDetail({ accountNumber: 'NOT APPLICABLE' });
        setSelectValue(''); // Reset selection
    };

    const handleEdit = (index, initialValue) => {
        if (initialValue === "1") {
            handleSaveNotAble();
        } else {
            setEditingIndex(index);
            setSelectValue(initialValue);
            setAccountNumber(''); // Clear account number when editing
        }
    };

    return (
        <div>
            {value !== null ? <p>{value}</p> :
                selectValue === "2" ? (
                    <div className="flex flex-row gap-2">
                        <input
                            placeholder={`ENTER ${placeholder}`}
                            type="text"
                            className="input input-sm input-bordered w-36 text-black"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            required
                        />
                        <IoIosSave size={"1.4rem"} color="white" className="mt-1" onClick={handleSave} />
                    </div>
                ) : (
                    <select
                        className="text-black w-44"
                        value={selectValue}
                        onChange={(e) => handleEdit(index, e.target.value)}
                    >
                        <option value="">{"Please select"}</option>
                        <option value="1">NOT APPLICABLE</option>
                        <option value="2">ENTER {placeholder}</option>
                    </select>
                )}
        </div>
    );
}
